<template>
  <CollapsibleCard v-model="actualCollapsed">
    <template #header>
      <div class="section-spacing-5">
        <div class="d-flex align-items-center">
          <div class="d-flex align-items-center">
            <h4 class="mb-0">
              <archived-label :disabled="!equipmentType.archived">
                {{ equipmentType.name }}
              </archived-label>
            </h4>
            <sera-button
              icon="fas fa-edit"
              class="edit-icon ml-2"
              @click="handleOnEdit"
            />
          </div>
        </div>
        <p v-if="equipmentType.description">
          <strong>Description: </strong> {{ equipmentType.description }}
        </p>
        <p v-if="equipmentType.included_in">
          <EntityIncludedIn :included-in="equipmentType.included_in" />
        </p>
      </div>
    </template>
    <template #body>
      <div
        v-if="equipmentType.component_types.length"
        class="components section-spacing-10"
      >
        <h5 class="mb-0">Components</h5>
        <ul>
          <li v-for="(component, index) in sortedComponents" :key="index">
            <div v-if="component.description" class="section-spacing-10">
              <strong>{{ component.name }}:</strong>&nbsp;
              <span>{{ component.description }}</span>
            </div>
            <div v-else>
              <strong>{{ component.name }}</strong>
            </div>
          </li>
        </ul>
      </div>
    </template>
  </CollapsibleCard>
</template>

<script>
import sortBy from "lodash/sortBy";

import ArchivedLabel from "@/components/ArchivedLabel.vue";
import SeraButton from "@/components/Button.vue";
import CollapsibleCard from "@/components/CollapsibleCard.vue";
import EntityIncludedIn from "@/components/EntityIncludedIn.vue";
import EquipmentType from "@/EquipmentTypes/EquipmentType.js";

export default {
  components: {
    CollapsibleCard,
    ArchivedLabel,
    SeraButton,
    EntityIncludedIn
  },
  props: {
    showEdit: {
      type: Boolean,
      default: true
    },
    equipmentType: {
      type: EquipmentType,
      default: null
    },
    collapsed: {
      type: Boolean,
      default: () => undefined
    }
  },
  emits: ["input", "edit"],
  data: function () {
    return {
      internalCollapsed: this.collapsed !== undefined ? this.collapsed : false
    };
  },
  computed: {
    sortedComponents() {
      return sortBy(this.equipmentType.component_types, (component) =>
        (component.name || "").toLowerCase()
      );
    },
    actualCollapsed: {
      get() {
        if (this.collapsed !== undefined) return this.collapsed;
        return this.internalCollapsed;
      },
      set(val) {
        this.$emit("input", val);
        this.internalCollapsed = val;
      }
    }
  },
  methods: {
    handleOnEdit() {
      this.$emit("edit", this.equipmentType);
    }
  }
};
</script>

<style lang="scss" scoped>
.components {
  ul {
    padding-left: 30px;
  }
}
</style>
